(() => {
  if (window.SKULL_MYSTERY_UPSELL_FINAL) return;
  window.SKULL_MYSTERY_UPSELL_FINAL = true;

  const CONFIG = {
    image: 'https://cdn.shopify.com/s/files/1/0602/8270/0004/files/Diseno_sin_titulo_11.png?v=1782978160',
    checkoutSelector: 'button#checkout.cart__checkout-button[name="checkout"][form="cart-form"]',
    price: 399,
    compareAt: 3000,
    stockLeft: 6,
    stockTotal: 60,
    maxQty: 3,
    variants: {
      S: 49260779798756,
      M: 49260785991908,
      L: 49260786024676,
      XL: 49260786057444,
      XXL: 49260786090212
    }
  };

  const state = {
    selectedSize: 'S',
    qty: 1,
    adding: false,
    loading: false,
    added: false,
    variants: {},
    continueCheckout: null,
    finish: null,
    seconds: 600,
    timerStarted: false
  };

  const css = `
  #skullMysteryUpsell,#skullMysteryUpsell *{box-sizing:border-box}
  #skullMysteryUpsell{position:fixed!important;inset:0!important;width:100%;height:100%;max-width:none;max-height:none;margin:0;border:0;background:transparent;color:#fff;display:none;align-items:center;justify-content:center;padding:clamp(8px,1.4vh,16px);font-family:Arial,Helvetica,sans-serif;overflow-y:auto}
  #skullMysteryUpsell::backdrop{background:transparent}
  #skullMysteryUpsell.is-open{display:flex!important}
  #skullMysteryUpsell:before{content:"";position:absolute;inset:0;background:rgba(0,0,0,.58);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px)}

  .skull-mu-wrap{position:relative;z-index:2;width:min(88vw,720px);max-height:calc(100dvh - 16px);color:#fff;display:flex;flex-direction:column;align-items:stretch}
  .skull-mu-top{text-align:center;margin-bottom:clamp(8px,1.6vh,16px);flex:0 0 auto}
  .skull-mu-top h2{margin:0 0 clamp(5px,.8vh,9px);font-size:clamp(22px,3.8vh,42px);line-height:.95;font-weight:1000;letter-spacing:-1px}
  .skull-mu-top p{margin:0 auto clamp(6px,1vh,10px);max-width:520px;font-size:clamp(11px,1.7vh,17px);line-height:1.04;color:#fff;font-weight:400}
  .skull-mu-top-timer{font-size:clamp(14px,2.2vh,19px);font-weight:900;line-height:1}

  .skull-mu-card{position:relative;background:#000;border-radius:clamp(20px,3vh,30px);padding:clamp(13px,2.2vh,22px) clamp(20px,4vw,38px) clamp(15px,2.3vh,25px);box-shadow:0 30px 78px rgba(0,0,0,.58);overflow-y:auto;max-height:calc(100dvh - 150px);min-height:0; border: 1px solid #545454}
  .skull-mu-window{display:flex;justify-content:space-between;align-items:center;margin-bottom:clamp(16px,2.7vh,25px)}
  .skull-mu-dots{display:flex;gap:7px}
  .skull-mu-dots span{width:clamp(11px,1.8vh,15px);height:clamp(11px,1.8vh,15px);border-radius:50%;display:block}
  .skull-mu-dots span:nth-child(1){background:#ff3b3b}.skull-mu-dots span:nth-child(2){background:#ffdc3d}.skull-mu-dots span:nth-child(3){background:#14c86e}
  .skull-mu-center-title{position:absolute;top:clamp(17px,2.5vh,25px);left:50%;transform:translateX(-50%);color:#aaa;font-size:clamp(14px,2.2vh,19px);font-weight:900;letter-spacing:.3px;text-transform:uppercase;white-space:nowrap}
  .skull-mu-close{width:clamp(30px,4vh,38px);height:clamp(30px,4vh,38px);border-radius:50%;border:2px solid #595959;background:transparent;color:#777;font-size:clamp(23px,3.7vh,30px);font-weight:900;line-height:1;display:grid;place-items:center;cursor:pointer;padding:0}
  /* Keep the Mystery Box artwork from intercepting the close button. */
  #skullMysteryUpsell .skull-mu-window{position:relative;z-index:20}
  #skullMysteryUpsell .skull-mu-close{position:relative;z-index:21;pointer-events:auto}
  #skullMysteryUpsell .skull-mu-img,#skullMysteryUpsell .skull-mu-img img{pointer-events:none!important;z-index:1}
  .skull-mu-hero{position:relative;min-height:clamp(86px,14vh,125px)}
  .skull-mu-copy{width:58%}
  .skull-mu-title{margin:0 0 clamp(7px,1.2vh,12px);color:#fff;font-size:clamp(22px,5vh,40px);line-height:.9;letter-spacing:-1.3px;font-weight:1000;font-style:italic;text-transform:uppercase}
  .skull-mu-sub{margin:0;color:#8f8f8f;font-size:clamp(11px,2.2vh,18px);line-height:1.08;font-weight:400}
  .skull-mu-sub b{color:#fff;font-weight:1000}
  .skull-mu-img{position:absolute;right:0;top:0;width:39%;max-width:240px}
  .skull-mu-img img{width:100%;display:block}
  .skull-mu-price{display:flex;align-items:center;gap:clamp(6px,1.6vh,12px);margin:clamp(7px,1.4vh,12px) 0 clamp(11px,2.2vh,20px)}
  .skull-mu-old{color:#8f8f8f;font-size:clamp(12px,2vh,18px);text-decoration:line-through;font-weight:500}
  .skull-mu-now{color:#fff;font-size:clamp(19px,3.7vh,29px);font-weight:1000;letter-spacing:-.7px}
  .skull-mu-badge{background:#ff1d25;color:#fff;border-radius:7px;padding:clamp(5px,.9vh,8px) clamp(7px,1.3vh,10px);font-size:clamp(12px,2.3vh,17px);font-weight:1000}
  .skull-mu-include{text-align:center;color:#aaa;font-size:clamp(11px,2vh,17px);line-height:1.2;margin:0 0 clamp(12px,2vh,19px)}
  .skull-mu-include b{color:#fff;font-weight:1000}
  .skull-mu-stock{margin:0 auto clamp(7px,1.2vh,11px);width:88%}
  .skull-mu-stock-row{display:flex;justify-content:space-between;align-items:center;margin-bottom:clamp(5px,1vh,8px);color:#aaa;font-size:clamp(10px,1.8vh,14px);font-weight:1000;text-transform:uppercase}
  .skull-mu-stock-row b{color:#ff2b35}
  .skull-mu-bar{height:clamp(8px,1.6vh,15px);border-radius:999px;background:#262626;overflow:hidden}
  .skull-mu-bar span{display:block;height:100%;width:12%;background:#ff1d25;border-radius:999px}
  .skull-mu-max{text-align:center;color:#aaa;font-size:clamp(10px,1.8vh,15px);margin:0 0 clamp(13px,2.2vh,22px); padding: 5px; background-color: #ffffff; color: #000000; border-radius: 6px; font-weight: 800;}
  .skull-mu-size-label{color:#fff;font-size:clamp(10px,1.8vh,14px);line-height:1.2;font-weight:1000;text-transform:uppercase;margin:0 0 clamp(7px,1.1vh,10px)}
  .skull-mu-sizes{display:grid;grid-template-columns:repeat(5,1fr);gap:clamp(5px,1vh,8px);margin-bottom:clamp(8px,1.3vh,12px)}
  .skull-mu-sizes button{height:clamp(32px,5.4vh,47px);border-radius:10px;border:2px solid #d9d9d9;background:#000;color:#fff;font-size:clamp(12px,2.3vh,17px);font-weight:1000;cursor:pointer}
  .skull-mu-sizes button.active{background:#ff1d25;border-color:#ff1d25}
  .skull-mu-actions{display:grid;grid-template-columns:minmax(72px,120px) 1fr;gap:clamp(7px,1.2vh,10px);margin-bottom:clamp(10px,1.8vh,17px)}
  .skull-mu-qty{height:clamp(35px,5.8vh,49px);border:2px solid #d9d9d9;border-radius:10px;display:flex;align-items:center;justify-content:space-around;color:#fff}
  .skull-mu-qty button{background:transparent;border:0;color:#fff;font-size:clamp(15px,2.5vh,20px);font-weight:900;cursor:pointer}
  .skull-mu-qty span{font-size:clamp(17px,3vh,22px);font-weight:900}
  .skull-mu-add{height:clamp(35px,5.8vh,49px);border:0;border-radius:10px;background:#ff1d25;color:#fff;font-size:clamp(9px,1.9vh,14px);font-weight:1000;text-transform:uppercase;cursor:pointer;padding:0 8px}
  .skull-mu-add[disabled]{opacity:.6;cursor:not-allowed}
  .skull-mu-skip{width:100%;border:0;background:transparent;color:#fff;font-size:clamp(10px,1.9vh,15px);line-height:1.2;text-decoration:underline;cursor:pointer}
  #skullMysteryUpsell button:disabled{opacity:.45;cursor:not-allowed}
  #skullMysteryUpsell button:focus-visible{outline:2px solid #fff;outline-offset:3px}
  .skull-mu-error{font-size:13px;line-height:1.4;color:#ffb8b8;text-align:center;margin:10px 0}

  @media(min-width:701px) and (max-height:820px){
    .skull-mu-wrap{width:min(84vw,680px)}
    .skull-mu-card{max-height:calc(100dvh - 125px);padding:14px 34px 18px}
    .skull-mu-top{margin-bottom:9px}
    .skull-mu-top h2{font-size:30px;margin-bottom:5px}
    .skull-mu-top p{font-size:13px;margin-bottom:6px}
    .skull-mu-top-timer{font-size:15px}
    .skull-mu-window{margin-bottom:16px}
    .skull-mu-hero{min-height:92px}
    .skull-mu-title{font-size:28px;margin-bottom:7px}
    .skull-mu-sub{font-size:12.5px}
    .skull-mu-img{width:33%;max-width:190px}
    .skull-mu-price{margin:5px 0 11px}
    .skull-mu-now{font-size:21px}
    .skull-mu-old{font-size:13px}
    .skull-mu-badge{font-size:12px}
    .skull-mu-include{font-size:12px;margin-bottom:10px}
    .skull-mu-stock-row{font-size:10.5px}
    .skull-mu-bar{height:8px}
    .skull-mu-max{font-size:11px;margin-bottom:12px}
    .skull-mu-sizes button{height:32px;font-size:12px}
    .skull-mu-qty,.skull-mu-add{height:34px}
    .skull-mu-skip{font-size:10.5px}
  }

  /* MÓVIL RESTAURADO */
  @media(max-width:700px){
    #skullMysteryUpsell{padding:7px;align-items:center}
    .skull-mu-wrap{width:100%;max-width:430px;max-height:none;display:block}
    .skull-mu-top{margin-bottom:14px}
    .skull-mu-top h2{font-size:24px;letter-spacing:-.8px;line-height:.97;margin-bottom:8px}
    .skull-mu-top p{font-size:12px;line-height:1.05;max-width:290px;margin-bottom:9px}
    .skull-mu-top-timer{font-size:16px}
    .skull-mu-card{border-radius:24px;padding:12px 18px 16px;max-height:70vh;overflow-y:auto}
    .skull-mu-window{margin-bottom:20px}
    .skull-mu-dots{gap:6px}
    .skull-mu-dots span{width:11px;height:11px}
    .skull-mu-center-title{top:18px;font-size:15px}
    .skull-mu-close{width:30px;height:30px;font-size:23px;border-width:2px}
    .skull-mu-hero{min-height:92px}
    .skull-mu-copy{width:56%}
    .skull-mu-title{font-size:30px;letter-spacing:-1px;margin-bottom:8px}
    .skull-mu-sub{font-size:15px;line-height:1.12;margin-bottom:9px}
    .skull-mu-img{width:50%;right:-1px;top:-34px}
    .skull-mu-price{gap:6px;margin-bottom:13px; margin-top: -10px;}
    .skull-mu-old{font-size:12px}
    .skull-mu-now{font-size:19px}
    .skull-mu-badge{font-size:12px;padding:6px 7px;border-radius:6px}
    .skull-mu-include{font-size:11.3px;margin-bottom:13px}
    .skull-mu-stock{width:100%;margin-bottom:8px}
    .skull-mu-stock-row{font-size:10.5px;margin-bottom:6px}
    .skull-mu-bar{height:9px}
    .skull-mu-max{font-size:12px;margin-bottom:16px}
    .skull-mu-size-label{font-size:10.4px;line-height:1.2;margin-bottom:8px}
    .skull-mu-sizes{gap:5px;margin-bottom:8px}
    .skull-mu-sizes button{height:34px;border-radius:8px;border-width:1.7px;font-size:12px}
    .skull-mu-actions{grid-template-columns:72px 1fr;gap:7px;margin-bottom:13px}
    .skull-mu-qty,.skull-mu-add{height:35px;border-radius:8px}
    .skull-mu-qty{border-width:1.7px}
    .skull-mu-qty button{font-size:15px}
    .skull-mu-qty span{font-size:17px}
    .skull-mu-add{font-size:9px;padding:0 6px}
    .skull-mu-skip{font-size:10px;line-height:1.2}
  }
 
#skullMuQty {
  display: flex !important;
  align-items: center;
  justify-content: center;
  transform-origin: center;
  animation: pulseBounce 1.5s ease-in-out infinite !important;
}

.skull-mu-qty button[data-plus] {
  transform-origin: center;
  animation: pulseBounce 1.5s ease-in-out infinite !important;
}

@keyframes pulseBounce {
  0% { transform: scale(1); }
  35% { transform: scale(1.5); }
  50% { transform: scale(0.92); }
  65% { transform: scale(1.12); }
  80% { transform: scale(0.98); }
  100% { transform: scale(1); }
}

  @media(max-width:390px){
    .skull-mu-top h2{font-size:22px}
    .skull-mu-card{padding:11px 16px 15px;border-radius:22px}
    .skull-mu-title{font-size:20px}
    .skull-mu-sub{font-size:10.8px}
    .skull-mu-now{font-size:18px}
    .skull-mu-badge{font-size:11.5px}
    .skull-mu-include{font-size:10.6px}
    .skull-mu-sizes button{font-size:11px}
    .skull-mu-add{font-size:8.5px}
  }
  .skull-mu-qty{position:relative;overflow:hidden;box-shadow:0 0 0 0 rgba(255,29,37,.45);animation:skullQtyPulse 1.8s ease-in-out infinite}
  .skull-mu-qty:after{content:"";position:absolute;inset:0;border-radius:inherit;pointer-events:none;background:linear-gradient(90deg,transparent,rgba(255,255,255,.12),transparent);transform:translateX(-120%);animation:skullQtySweep 2.2s ease-in-out infinite}
  .skull-mu-qty button[data-plus]{color:#ff1d25!important;font-size:1.18em!important;text-shadow:0 0 14px rgba(255,29,37,.7);animation:skullPlusNudge 1.15s ease-in-out infinite}
  #skullMuQty{display:inline-block;min-width:24px;text-align:center;transform-origin:center}
  [data-plus].skull-plus-bump{  animation: pulseBounce 1.5s ease-in-out infinite; transform-origin: center;}
  @keyframes skullQtyPulse{0%,100%{box-shadow:0 0 0 0 rgba(255,29,37,0)}50%{box-shadow:0 0 0 3px rgba(255,29,37,.22)}}
  @keyframes skullQtySweep{0%,35%{transform:translateX(-120%)}65%,100%{transform:translateX(120%)}}
  @keyframes skullPlusNudge{0%,100%{transform:translateX(0) scale(1)}45%{transform:translateX(2px) scale(1.14)}}
  @keyframes skullQtyBump{0%{transform:scale(1)}45%{transform:scale(1.36)}100%{transform:scale(1)}}
  @keyframes skullPlusClick{0%{transform:scale(1)}50%{transform:scale(1.55)}100%{transform:scale(1)}}
  @media(min-width:701px){.skull-mu-actions{grid-template-columns:190px 1fr}.skull-mu-qty{height:68px}.skull-mu-qty button{font-size:30px}.skull-mu-qty span{font-size:32px}}
  @media(max-width:700px){.skull-mu-actions{grid-template-columns:92px 1fr!important}.skull-mu-qty{height:42px!important}.skull-mu-qty button{font-size:20px!important}.skull-mu-qty span{font-size:22px!important}}

  /* QTY + CTA FINAL */
  .skull-mu-actions{
    grid-template-columns:clamp(145px,30%,220px) 1fr !important;
    align-items:stretch;
  }

  .skull-mu-qty{
    position:relative;
    overflow:hidden;
    display:grid !important;
    grid-template-columns:1fr 1fr 1fr;
    padding:0 !important;
    box-shadow:0 0 0 0 rgba(255,29,37,.45);
    animation:skullQtyPulse 1.9s ease-in-out infinite;
  }

  .skull-mu-qty button,
  .skull-mu-qty span{
    height:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    border:0;
    line-height:1.5;
  }

  .skull-mu-qty button[data-minus],
  .skull-mu-qty span{
    border-right:2px solid rgba(217,217,217,.6);
  }

  .skull-mu-qty button[data-plus]{
    color:#ff1d25 !important;
    text-shadow:0 0 16px rgba(255,29,37,.7);
    animation:skullPlusPulse 1.05s ease-in-out infinite;
  }

  #skullMuQty{
    min-width:0;
    transform-origin:center;
    animation:skullNumberPulse 1.35s ease-in-out infinite;
  }



  .skull-mu-add{
    position:relative;
    overflow:hidden;
    height:auto !important;
    min-height:inherit;
    animation:skullAddBreath 1.7s ease-in-out infinite;
  }

  .skull-mu-add:after{
    content:"";
    position:absolute;
    top:0;
    left:-120%;
    width:65%;
    height:100%;
    background:linear-gradient(90deg,transparent,rgba(255,255,255,.28),transparent);
    transform:skewX(-20deg);
    animation:skullAddShine 2.2s ease-in-out infinite;
  }

  .skull-mu-add.skull-add-bump{
    animation:skullAddClick .28s ease-out;
  }

  .skull-mu-max{
    position:relative;
    overflow:hidden;
    display:block;
    width:max-content;
    max-width:100%;
    margin-left:auto !important;
    margin-right:auto !important;
  }

  .skull-mu-max:after{
    content:"";
    position:absolute;
    top:0;
    left:-45%;
    width:45%;
    height:100%;
    background:linear-gradient(90deg,transparent,rgba(255,255,255,.65),transparent);
    transform:skewX(-18deg);
    animation:skullTextShine 2.1s ease-in-out infinite;
  }

  @keyframes skullQtyPulse{
    0%,100%{box-shadow:0 0 0 0 rgba(255,29,37,0)}
    50%{box-shadow:0 0 0 3px rgba(255,29,37,.22)}
  }

  @keyframes skullPlusPulse{
    0%,100%{transform:scale(1)}
    45%{transform:scale(1.22)}
  }

  @keyframes skullNumberPulse{
    0%,100%{transform:scale(1)}
    50%{transform:scale(1.12)}
  }

  @keyframes skullQtyBump{
    0%{transform:scale(1)}
    45%{transform:scale(1.36)}
    100%{transform:scale(1)}
  }

  @keyframes skullPlusClick{
    0%{transform:scale(1)}
    50%{transform:scale(1.55)}
    100%{transform:scale(1)}
  }

  @keyframes skullAddBreath{
    0%,100%{box-shadow:0 0 0 0 rgba(255,29,37,0)}
    50%{box-shadow:0 0 0 3px rgba(255,29,37,.20)}
  }

  @keyframes skullAddClick{
    0%{transform:scale(1)}
    45%{transform:scale(1.04)}
    100%{transform:scale(1)}
  }

  @keyframes skullAddShine{
    0%,38%{left:-120%}
    70%,100%{left:130%}
  }

  @keyframes skullTextShine{
    0%,42%{left:-55%}
    75%,100%{left:115%}
  }

  @media(min-width:701px){
    .skull-mu-actions{grid-template-columns:210px 1fr !important}
    .skull-mu-qty,.skull-mu-add{height:68px !important}
    .skull-mu-qty button{font-size:30px !important}
    .skull-mu-qty span{font-size:32px !important}
  }

  @media(max-width:700px){
    .skull-mu-actions{grid-template-columns:112px 1fr !important}
    .skull-mu-qty,.skull-mu-add{height:42px !important}
    .skull-mu-qty button{font-size:20px !important}
    .skull-mu-qty span{font-size:22px !important}
    .skull-mu-add{font-size:9px !important}
  }

  `;

  function html(){
    const pct=Math.max(1,Math.min(100,CONFIG.stockLeft/CONFIG.stockTotal*100));
    return `<dialog id="skullMysteryUpsell" aria-labelledby="skullMuHeading"><div class="skull-mu-wrap">
      <div class="skull-mu-top"><h2>Tenemos una oferta especial para ti.</h2><p>no volverá a aparecer al cerrarla y regresara a<br>$3,000 MXN.</p><div class="skull-mu-top-timer">⏱ <span id="skullMuTimerTop">10:00</span></div></div>
      <div class="skull-mu-card">
        <div class="skull-mu-window"><div class="skull-mu-dots"><span></span><span></span><span></span></div><div class="skull-mu-center-title">SÓLO POR AHORA.</div><button class="skull-mu-close" data-skip type="button" aria-label="Continuar al pago sin Mystery Box">×</button></div>
        <div class="skull-mu-hero"><div class="skull-mu-copy"><h2 class="skull-mu-title" id="skullMuHeading">MISTERY BOX</h2><p class="skull-mu-sub">Hasta <b>$3,000 MXN</b> en productos de SKULL sorpresa.</p></div><div class="skull-mu-img"><img src="${CONFIG.image}" alt="Mistery Box"></div></div>
        <div class="skull-mu-price"><span class="skull-mu-old">$ 3,000</span><span class="skull-mu-now">$399 mxn</span><span class="skull-mu-badge">-87%</span></div>
        <p class="skull-mu-include">Puede incluir: <b>Playera Cloud Cotton®, Básica Pro®, Polo Pro®, termos y gorras.</b></p>
        <div class="skull-mu-stock"><div class="skull-mu-stock-row"><span>QUEDAN <b>6 MISTERY BOX</b></span><span>DE 60.</span></div><div class="skull-mu-bar"><span style="width:${pct}%"></span></div></div>
        <p class="skull-mu-max">⚠️ Puedes comprar 3 Mistery box Máximo.</p>
        <div class="skull-mu-size-label">ELIGE LA TALLA DE LOS ARTICULOS DE TU MISTERY BOX.</div>
        <div class="skull-mu-sizes">${Object.keys(CONFIG.variants).map(s=>`<button type="button" data-size="${s}" class="${s===state.selectedSize?'active':''}">${s}</button>`).join('')}</div>
        <div class="skull-mu-actions"><div class="skull-mu-qty"><button type="button" data-minus>-</button><span id="skullMuQty">1</span><button type="button" data-plus>+</button></div><button class="skull-mu-add" id="skullMuAdd" type="button">AGREGAR 1 MISTERY BOX</button></div>
        <p class="skull-mu-error" role="alert" hidden></p>
        <button class="skull-mu-skip" data-skip type="button">No gracias, continuar al pago</button>
      </div></div></dialog>`;
  }

  function inject(){
    if(!document.getElementById('skullMysteryUpsellCSS')){const s=document.createElement('style');s.id='skullMysteryUpsellCSS';s.textContent=css;document.head.appendChild(s)}
    if(!document.getElementById('skullMysteryUpsell'))document.body.insertAdjacentHTML('beforeend',html());
    bind();updateCta();
  }

  const root=window.Shopify?.routes?.root||'/';
  const modal=()=>document.getElementById('skullMysteryUpsell');
  function error(message=''){
    const el=modal().querySelector('.skull-mu-error');el.textContent=message;el.hidden=!message;
  }
  async function json(path,body){
    const response=await fetch(root+path,{credentials:'same-origin',cache:'no-store',signal:AbortSignal.timeout(15000),...(body?{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}:{})});
    const data=await response.json();if(!response.ok)throw Error(data.description||'No se pudo completar. Inténtalo de nuevo.');return data;
  }
  async function loadVariants(){
    state.loading=true;updateCta();
    try{
      const variants=await Promise.all(Object.entries(CONFIG.variants).map(async([size,id])=>[size,await json('variants/'+id+'.js')]));
      state.variants=Object.fromEntries(variants);
      if(!state.variants[state.selectedSize]?.available)state.selectedSize=variants.find(([,v])=>v.available)?.[0];
      if(!state.selectedSize)error('La Mystery Box está agotada. Puedes continuar al pago sin ella.');
    }catch{error('No se pudo consultar la disponibilidad de la caja. Puedes continuar sin ella.');}
    finally{state.loading=false;updateCta();}
  }
  function open(continueCheckout){
    if(!modal())inject();
    if(modal().open)return state.pending;
    state.continueCheckout=continueCheckout;state.added=false;error();
    state.pending=new Promise(resolve=>{state.finish=resolve;});
    modal().classList.add('is-open');
    try{modal().showModal();}catch(e){modal().classList.remove('is-open');state.finish();throw e;}
    startTimer();loadVariants();return state.pending;
  }
  async function checkout(){
    if(state.adding)return;state.adding=true;error();updateCta();
    try{await state.continueCheckout();}
    catch(e){error(e.name==='TimeoutError'?'La conexión está tardando. Intenta continuar de nuevo.':e.message);}
    finally{state.adding=false;updateCta();}
  }

  function updateCta(){
    const btn = document.getElementById('skullMuAdd');
    if(!btn) return;
    const variant=state.variants[state.selectedSize];
    btn.disabled=state.adding||(!state.added&&(state.loading||!variant?.available));
    btn.textContent=state.adding?'PREPARANDO TU PEDIDO…':state.added?'CONTINUAR AL PAGO':state.loading?'CONSULTANDO DISPONIBILIDAD…':`AGREGAR ${state.qty} MISTERY BOX${state.qty>1?'ES':''}`;
    modal().querySelectorAll('[data-skip]').forEach(b=>b.disabled=state.adding);
    modal().querySelectorAll('[data-size]').forEach(b=>{b.disabled=state.adding||state.added||state.loading||!state.variants[b.dataset.size]?.available;b.classList.toggle('active',b.dataset.size===state.selectedSize);});
    modal().querySelector('[data-minus]').disabled=state.adding||state.added||state.qty<=1;
    modal().querySelector('[data-plus]').disabled=state.adding||state.added||state.qty>=CONFIG.maxQty;
    if(variant){modal().querySelector('.skull-mu-now').textContent=new Intl.NumberFormat('es-MX',{style:'currency',currency:window.Shopify?.currency?.active||'MXN',maximumFractionDigits:2}).format(variant.price/100);}
  }

  function bumpQtyAnimation(){
    const qtyEl = document.getElementById('skullMuQty');
    const plusEl = modal().querySelector('[data-plus]');
    const addBtn = document.getElementById('skullMuAdd');

    if(qtyEl){
      qtyEl.classList.remove('skull-qty-bump');
      void qtyEl.offsetWidth;
      qtyEl.classList.add('skull-qty-bump');
    }

    if(plusEl){
      plusEl.classList.remove('skull-plus-bump');
      void plusEl.offsetWidth;
      plusEl.classList.add('skull-plus-bump');
    }

    if(addBtn){
      addBtn.classList.remove('skull-add-bump');
      void addBtn.offsetWidth;
      addBtn.classList.add('skull-add-bump');
    }
  }

  async function add(){
    if(state.added)return checkout();
    if(state.adding||state.loading||!state.variants[state.selectedSize]?.available)return;
    state.adding=true;error();updateCta();
    try{
      // Read before adding, including a retry after an ambiguous network failure.
      // The per-offer key lets us recognize a successful add without duplicating it.
      state.offerKey||=crypto.randomUUID();
      const cart=await json('cart.js'),alreadyAdded=cart.items.some(i=>i.properties?._skull_mystery_offer===state.offerKey);
      if(!alreadyAdded){
        const existing=cart.items.filter(i=>Object.values(CONFIG.variants).includes(i.variant_id)).reduce((n,i)=>n+i.quantity,0);
        if(existing+state.qty>CONFIG.maxQty)throw Error('El máximo es de 3 Mystery Box por pedido. Reduce la cantidad o continúa sin agregar otra.');
        await json('cart/add.js',{items:[{id:CONFIG.variants[state.selectedSize],quantity:state.qty,properties:{_upsell:'Mistery Box',Talla:state.selectedSize,_skull_mystery_offer:state.offerKey}}]});
      }
      state.added=true;
      await state.continueCheckout();
    }catch(e){error(e.name==='TimeoutError'?'La conexión está tardando. Puedes reintentar; no se duplicará la caja.':e.message);}
    finally{state.adding=false;updateCta();}
  }

  function bind(){
    if(modal().dataset.bound)return;modal().dataset.bound='true';
    modal().querySelectorAll('[data-size]').forEach(b=>{b.onclick=()=>{state.selectedSize=b.dataset.size;updateCta();}});
    modal().querySelector('[data-minus]')?.addEventListener('click',()=>{state.qty=Math.max(1,state.qty-1);document.getElementById('skullMuQty').textContent=state.qty;updateCta();bumpQtyAnimation()});
    modal().querySelector('[data-plus]')?.addEventListener('click',()=>{state.qty=Math.min(CONFIG.maxQty,state.qty+1);document.getElementById('skullMuQty').textContent=state.qty;updateCta();bumpQtyAnimation()});
    document.getElementById('skullMuAdd')?.addEventListener('click',add);
    modal().querySelectorAll('[data-skip]').forEach(b=>b.addEventListener('click',checkout));
    modal().addEventListener('cancel',e=>{e.preventDefault();if(!state.adding)modal().close();});
    modal().addEventListener('close',()=>{modal().classList.remove('is-open');state.finish?.();state.finish=null;});
  }

  // Explicit integration: never swallow all document clicks or submit events.
  window.SKULL_MYSTERY_OPEN=open;

  function startTimer(){if(state.timerStarted)return;state.timerStarted=true;setInterval(()=>{state.seconds=Math.max(0,state.seconds-1);const m=String(Math.floor(state.seconds/60)).padStart(2,'0'),s=String(state.seconds%60).padStart(2,'0'),top=document.getElementById('skullMuTimerTop');if(top)top.textContent=`${m}:${s}`},1000)}
  // open() prepares the offer before showing it; closed pages need no modal or artwork.
})();
